import React from "react";
import { Loader } from "lucide-react";
import "./Loading.css";

export default function LoadingScreen({ lang, minHeight = "60vh" }) {
  const isAr = lang === "ar";
  return (
    <div className="loading-screen-minimal" dir={isAr ? "rtl" : "ltr"} style={{ minHeight }}>
      <Loader className="loading-spin-icon" size={28} />
      <p>{isAr ? "جاري التحميل..." : "Loading..."}</p>
    </div>
  );
}